import {FetchMethod} from "./interfaces";

export const URLS = {
    [FetchMethod.POST]: {
       CONTACT: 'contact'
    },
};